import React from "react";

import SiteHead from "@/layouts/Head";
import Layout from "@/layouts/Layout";

const NotFound = () => {

    return (
		<React.Fragment>
			<SiteHead title="Not Found" />
			<Layout>
                <div className="notfound-container">
                    <h3 className="notfound-title">Sorry, the page you're looking for does not exist.</h3>
                </div>
			</Layout>
		</React.Fragment>
	);
};

export default NotFound;
